import type { ReactNode } from "react";
import Breadcrumb, { type Crumb } from "@/components/base/Breadcrumb";

interface PageHeaderProps {
  title: string;
  desc?: string;
  breadcrumb: Crumb[];
  aside?: ReactNode;
}

export default function PageHeader({ title, desc, breadcrumb, aside }: PageHeaderProps) {
  return (
    <section className="relative w-full overflow-hidden bg-primary-950">
      <div className="absolute inset-0 opacity-[0.14]" style={{ backgroundImage: "radial-gradient(circle at 20% 20%, oklch(var(--accent-500)) 0, transparent 45%), radial-gradient(circle at 80% 80%, oklch(var(--primary-400)) 0, transparent 50%)" }} />
      <div className="relative mx-auto w-full max-w-page px-4 pb-10 pt-28 md:px-6 md:pb-14 md:pt-36">
        <div className="mb-4 [&_a]:text-background-300 [&_span]:text-background-100 [&_i]:text-background-400">
          <Breadcrumb items={breadcrumb} />
        </div>
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <h1 className="font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">{title}</h1>
            {desc && <p className="mt-4 text-sm leading-relaxed text-background-300 md:text-base">{desc}</p>}
          </div>
          {aside && <div className="shrink-0">{aside}</div>}
        </div>
      </div>
    </section>
  );
}